import {TAB_HIDE, TAB_DISABLE} from '../../../common/tabs/tabs.constants';
import {IDS} from './requirements-assessment-action-id.constants';
import {INIT_DASHBOARD} from "../../../common/navigation/navigation.actions.types";

const queryParams = ['requirement', 'year', 'slo', 'hof'];

// update navigation.customBackState
// so that clicking nav panel back button from custom dashboard can trigger custom back function
const onExitFromTab = ($ngRedux, $transition$) => {
    // activate custom back state only if navigation back button was pushed
    if ($transition$.to().name === IDS.app_accreditation_scheme_requirements_assessment_dashboard) {
        $ngRedux.dispatch({
            type: INIT_DASHBOARD,
            customBackState: 'app.accreditation.scheme.dashboard',
        });
    }
}
onExitFromTab.$inject = ['$ngRedux','$transition$'];

export const rcoRequirementsAssessmentMainState = {
    name: IDS.app_accreditation_scheme_requirements_assessment,
    abstract: true,
    redirectTo: IDS.app_accreditation_scheme_requirements_assessment_dashboard,
    url: '/:itemCode',
}

export const rcoRequirementsAssessmentDashboardState = {
    name: IDS.app_accreditation_scheme_requirements_assessment_dashboard,
    url: `/dashboard?${queryParams.join('&')}`,
    component: 'dashboard',
};

export const rcoRequirementsAssessmentTabsState = {
    name: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
    redirectTo: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
    url: `/evidence?${queryParams.join('&')}`,
    component: 'tabs',
};

export const rcoRequirementsAssessmentEvidenceGroupsState = {
    name: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
    url: '/list',
    // component: 'accRequirementsAssessmentEvidenceGroups',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_DISABLE,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: [
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details,
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_history,
            ]
        });
        $ngRedux.dispatch({
            type: TAB_HIDE,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: [
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request,
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_improvement,
            ]
        });
    },
    onExit: onExitFromTab
};
rcoRequirementsAssessmentEvidenceGroupsState.onEnter.$inject = ['$ngRedux'];


export const rcoRequirementsAssessmentEvidenceGroupDetailsState = {
    name: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details,
    url: '/details',
    // component: 'accRequirementsAssessmentEvidenceGroupDetails',
};

export const rcoRequirementsAssessmentEvidenceGroupDocRevisionRequestState = {
    name: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request,
    url: '/revision-request',
    // component: 'accRequirementsAssessmentEvidenceGroupDocRevisionRequest',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_DISABLE,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: [
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details,
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_history,
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_improvement,
            ]
        })
    },
    onExit: onExitFromTab
};
rcoRequirementsAssessmentEvidenceGroupDocRevisionRequestState.onEnter.$inject = ['$ngRedux'];

export const rcoRequirementsAssessmentEvidenceGroupImprovement = {
    name: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_improvement,
    url: '/improvement-action',
    // component: 'accRequirementsAssessmentEvidenceGroupImprovement',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_DISABLE,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: [
                IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request,
            ]
        })
    },
    onExit: onExitFromTab
};
rcoRequirementsAssessmentEvidenceGroupImprovement.onEnter.$inject = ['$ngRedux'];

export const rcoRequirementsAssessmentEvidenceGroupHistoryState = {
    name: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_history,
    url: '/requirementHistory',
    onExit: onExitFromTab,
};